import React from "react";
import { ArrowPathIcon } from "@heroicons/react/24/solid";
import { CameraIcon } from "@heroicons/react/24/outline";

const EditShopBrandsForm = ({
  editForm,
  onChange,
  onFileChange,
  onSubmit,
  onCancel,
  isLoading,
}) => {
  return (
    <form
      onSubmit={onSubmit}
      className="flex flex-col gap-4 p-6 bg-white rounded-lg shadow-lg w-[90%] max-w-2xl"
    >
      <h2 className="text-xl font-bold text-center text-black">Edit Item</h2>
      <div className="flex flex-col gap-2">
        <label className="text-sm font-semibold text-black">Name (EN)</label>
        <input
          type="text"
          placeholder="Name EN"
          name="nameEn"
          className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-sm"
          value={editForm.nameEn}
          onChange={onChange}
          required
        />
      </div>
      <div className="flex flex-col gap-2">
        <label className="text-sm font-semibold text-black">Name (AR)</label>
        <input
          type="text"
          name="nameAr"
          placeholder="Name AR"
          className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-sm"
          value={editForm.nameAr}
          onChange={onChange}
        />
      </div>

      <div className="flex flex-col gapn-2">
        <label className="text-sm font-semibold text-black">Website link</label>
        <input
          type="text"
          name="link"
          placeholder="Website link"
          className="w-full px-2 py-2 text-xs text-black bg-gray-100 border rounded-sm"
          value={editForm.link}
          onChange={onChange}
        />
      </div>
      <div className="flex flex-col w-1/3 gap-2 max-w-1/2">
        {/* Hidden File Input */}
        <input
          id="upload-image"
          type="file"
          name="image"
          accept="image/*"
          className="hidden"
          onChange={onFileChange}
        />

        {/* Custom Button */}
        <label
          htmlFor="upload-image"
          className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-white transition bg-black border border-black cursor-pointer hover:bg-gray-800"
        >
          <CameraIcon className="w-4 h-4" />
          Add a picture
        </label>
        {editForm.image && (
          <span className="inline-block text-xs text-gray-600">
            {editForm.image.name}
          </span>
        )}
      </div>

      {/* <div className="flex flex-col">
        <label className="text-sm font-semibold text-black">Name (EN)</label>
        <input
          type="text"
          name="nameEn"
          value={editForm.nameEn}
          onChange={onChange}
          className="px-3 py-1 text-black bg-gray-100 border rounded-md"
        />
      </div>

      <div className="flex flex-col">
        <label className="text-sm font-semibold text-black">Name (AR)</label>
        <input
          type="text"
          name="nameAr"
          value={editForm.nameAr}
          onChange={onChange}
          className="px-3 py-1 text-black bg-gray-100 border rounded-md"
        />
      </div>

      <div className="flex flex-col ">
        <label className="text-sm font-semibold text-black">Image</label>
        <input
          type="file"
          name="image"
          accept="image/*"
          onChange={onFileChange}
          className="px-3 py-1 text-black bg-gray-100 border rounded-md"
        />
      </div> */}

      <div className="flex justify-end col-span-2 mt-2 space-x-3">
        {isLoading ? null : (
          <button
            className="px-4 py-2 text-white duration-300 bg-gray-600 rounded-lg hover:bg-gray-800"
            onClick={onCancel}
          >
            Cancel
          </button>
        )}
        {isLoading ? (
          <ArrowPathIcon className="w-10 h-10 p-2 text-white rounded-full animate-spin bg-custom-yellow" />
        ) : (
          <button
            type="submit"
            className="px-4 py-2 text-white duration-300 rounded-lg bg-custom-yellow hover:bg-yellow-600"
          >
            Submit
          </button>
        )}
      </div>
    </form>
  );
};

export default EditShopBrandsForm;
